import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import WagonProductList from '../WagonProductList/WagonProductList';

export default function TechnicalDetailsUnderFrame(props) {
  const { wagonTechnicalDetails, classes, expanded, handleChange } = props;
  const [wagonTechnicalDetailsState, setWagonTechnicalDetailsState] =
    React.useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (wagonTechnicalDetails !== undefined) {
      setWagonTechnicalDetailsState(wagonTechnicalDetails);
    }
  }, [wagonTechnicalDetails]);
  return (
    <div>
      {wagonTechnicalDetailsState && (
        <Accordion
          className={classes.accordion}
          expanded={expanded}
          onChange={handleChange}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.heading}>
              {t('Technical details under frame')}
            </Typography>
            <Typography className={classes.secondaryHeading}>
              {t('Find here all technical details under frame for this wagon')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.container}>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('volume')} (m3)
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Max gross weight')} (T)
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Axles')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Construction year frame')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('tara')} (T)
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.volume !== null
                      ? wagonTechnicalDetailsState.volume
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.maxGrossWeight !== null
                      ? wagonTechnicalDetailsState.maxGrossWeight
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.axles !== null
                      ? wagonTechnicalDetailsState.axles
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.constructionYearFrame !== null
                      ? wagonTechnicalDetailsState.constructionYearFrame
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.tara !== null
                      ? wagonTechnicalDetailsState.tara
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={4}>
                  <FormLabel className={classes.formLabel}>
                    {t('Lengths over buffers (mm)')}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel className={classes.formLabel}>
                    {t('Weighing length (mm)')}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel className={classes.formLabel}>
                    {t('Max height')}
                  </FormLabel>
                </Grid>

                <Grid item xs={4}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.lengthOverBuffers !== null &&
                    wagonTechnicalDetailsState.lengthOverBuffers !== ''
                      ? wagonTechnicalDetailsState.lengthOverBuffers
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.weighingLength !== null
                      ? wagonTechnicalDetailsState.weighingLength
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.maxHeight !== null
                      ? wagonTechnicalDetailsState.maxHeight
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
              <Grid container spacing={0} alignItems="center" justify="center">
                <WagonProductList
                  products={wagonTechnicalDetailsState.products}
                />
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
